module.exports = __webpack_public_path__ + "img/pr-4.ab2bd0e5.png";